import { Filter } from '@anytag/shared-molecules';
import { usePaymentsFilter } from './hooks';
import { Template, TemplateProps } from './Template';

export type PaymentsFilterProps = Omit<TemplateProps, 'onSubmit'>;

export const PaymentsFilter = (props: PaymentsFilterProps) => {
  const { filter, setFilterForm } = usePaymentsFilter();

  return (
    <Filter.Provider onSubmit={setFilterForm} values={filter}>
      <Template {...props} />
    </Filter.Provider>
  );
};

export { usePaymentsFilter };
export * from './schemaTypes';
